import Lenis from 'lenis';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';


export default function initSmoothPage() {
  window.lenis = new Lenis();
  window.lenis.on('scroll', ScrollTrigger.update);

  gsap.ticker.add((time) => {
    window.lenis.raf(time * 1000); // Convert time from seconds to milliseconds
  });

  // Disable lag smoothing in GSAP to prevent any delay in scroll animations
  gsap.ticker.lagSmoothing(0);
}